var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 78,
    viewBox: "0 0 80 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1610_4578)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1610_4578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1474 8.05311L52.8556 6.34902C45.895 -1.20944 33.9595 -1.20944 26.9988 6.34902L25.6589 8.05311",
    stroke: "#006CFA",
    strokeWidth: 1.37427,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8524 26.9287L3.24583 36.6242",
    stroke: "#006CFA",
    strokeWidth: 1.37427,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2452 39.9842L10.5168 15.4329C10.5168 11.3582 13.8219 8.0531 17.8966 8.0531H58.8841L68.2497 17.2675L69.1842 39.6681",
    stroke: "#006CFA",
    strokeWidth: 1.37427,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7383 76.3129H4.2628C2.59307 76.3129 1.23942 74.9592 1.23942 73.2895V39.4482C1.23942 37.1463 3.7131 35.6896 5.72639 36.8096L36.8879 54.146C38.7294 55.1698 40.9626 55.1698 42.8041 54.1529L74.2816 36.7822C76.2949 35.669 78.7617 37.1257 78.7617 39.4276V73.2895C78.7617 74.9592 77.4081 76.3129 75.7383 76.3129V76.3129Z",
    stroke: "#006CFA",
    strokeWidth: 1.37427,
    strokeMiterlimit: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8624 48.5872L2.01567 75.296",
    stroke: "#006CFA",
    strokeWidth: 1.37427,
    strokeMiterlimit: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2313 48.5872L77.0781 75.296",
    stroke: "#006CFA",
    strokeWidth: 1.37427,
    strokeMiterlimit: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7513 37.3593C49.7513 30.1307 55.6057 24.2694 62.8412 24.2694C70.0767 24.2694 75.931 30.1307 75.931 37.3593C75.931 44.5879 70.0698 50.456 62.8412 50.456C55.6125 50.456 49.7513 44.5948 49.7513 37.3593Z",
    fill: "#006CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2408 31.2714L61.92 41.5715L57.0689 36.8371",
    stroke: "white",
    strokeWidth: 0.858916,
    strokeMiterlimit: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9459 29.5741L72.5785 30.9346",
    stroke: "white",
    strokeWidth: 0.858916,
    strokeMiterlimit: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7629 24.7643L73.9461 29.5742",
    stroke: "#006CFA",
    strokeWidth: 0.858916,
    strokeMiterlimit: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3791 32.6663H18.8975C18.5787 32.6663 18.3203 32.9247 18.3203 33.2435V33.3465C18.3203 33.6653 18.5787 33.9237 18.8975 33.9237H47.3791C47.6979 33.9237 47.9563 33.6653 47.9563 33.3465V33.2435C47.9563 32.9247 47.6979 32.6663 47.3791 32.6663Z",
    fill: "#DFE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3791 26.9973H18.8975C18.5787 26.9973 18.3203 27.2557 18.3203 27.5745V27.6776C18.3203 27.9964 18.5787 28.2548 18.8975 28.2548H47.3791C47.6979 28.2548 47.9563 27.9964 47.9563 27.6776V27.5745C47.9563 27.2557 47.6979 26.9973 47.3791 26.9973Z",
    fill: "#DFE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3036 38.0739H19.4195C19.1007 38.0739 18.8423 38.3323 18.8423 38.651V38.7541C18.8423 39.0729 19.1007 39.3313 19.4195 39.3313H30.3036C30.6224 39.3313 30.8808 39.0729 30.8808 38.7541V38.651C30.8808 38.3323 30.6224 38.0739 30.3036 38.0739Z",
    fill: "#DFE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1257 15H19.4472C18.8248 15 18.3203 15.5045 18.3203 16.1269V21.459C18.3203 22.0814 18.8248 22.5859 19.4472 22.5859H28.1257C28.748 22.5859 29.2526 22.0814 29.2526 21.459V16.1269C29.2526 15.5045 28.748 15 28.1257 15Z",
    fill: "#DFE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0909 17.2607H61.5082C60.0583 17.2607 58.8833 16.0857 58.8833 14.6358V8.0531L68.0978 17.2676L68.0909 17.2607Z",
    fill: "#006CFA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1610_4578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 77.4459,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1610_4578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.8966,
    height: 77.007,
    fill: "white",
    transform: "translate(0.551712 -0.00695801)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCheck);
export default __webpack_public_path__ + "static/media/emailCheck.7db1c94b9f10af0f822b3a127050dcd8.svg";
export { ForwardRef as ReactComponent };